import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { MarketplaceCategoryService } from '../../../../core/services/marketplaceCategory.service';
import { fromEvent as observableFromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { FuseDeleteDialogComponent } from '../../../../core/components/delete-dialog/delete-dialog.component';
import { EditMarketplaceCategoryModal } from './edit-modal/edit-marketplace-category.modal';

@Component({
  selector: 'app-marketplace-categories',
  templateUrl: './marketplace-categories.component.html',
  styleUrls: ['./marketplace-categories.component.scss'],
  standalone: false
})

export class MarketplaceCategoriesComponent implements OnInit {
  search = '';
  @ViewChild('filter', {static: true}) filter: ElementRef;
  marketplaceCategories = [];

  constructor(public marketplaceCategoryService: MarketplaceCategoryService,
              public dialog: MatDialog, public toastr: ToastrService,
              public translate: TranslateService) {
  }
  ngOnInit() {
    observableFromEvent(this.filter.nativeElement , 'keyup').pipe(
      debounceTime(800),
      distinctUntilChanged())
      .subscribe(() => {
        if (this.filter.nativeElement.value && this.filter.nativeElement.value.replace(/ /g, '')
          && this.filter.nativeElement.value !== null && this.filter.nativeElement.value !== 'null') {
          this.search = this.filter.nativeElement.value;
          this.getMarketplaceCategories();
        } else if ((!this.filter.nativeElement.value || this.filter.nativeElement.value === '') && this.search){
          this.search = '';
          this.getMarketplaceCategories();
        }
      });
    this.getMarketplaceCategories();
  }

  getMarketplaceCategories() {
    this.marketplaceCategoryService.getMarketplaceCategory(this.search).subscribe((res: any) => {
      this.marketplaceCategories = res;
    });
  }

  editMarketplaceCategory(id, name) {
    const dialogRef = this.dialog.open(EditMarketplaceCategoryModal , {
      width: '400px',
      data: {data: name}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = {
          id: id,
          name: result.name
        };
        this.marketplaceCategoryService.addMarketplaceCategory(data).subscribe((res: any) => {
          if (res) {
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('marketplaces.marketplace_category_edited');
            this.toastr.success(msg, title);
            this.getMarketplaceCategories();
          }
        });
      }
    });
  }

  deleteMarketplaceCategory (id) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent,
      { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'Delete' , message: 'marketplaces.delete_marketplace_category'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.marketplaceCategoryService.deleteMarketplaceCategory(id).subscribe((res: any) => {
          if (res && !res.error) {
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('marketplaces.marketplace_category_deleted');
            this.toastr.success(msg, title);
            this.getMarketplaceCategories();
          }
        });
      }
    });
  }

  editMarketplaceSubCategory(subCat, catId) {
    const dialogRef = this.dialog.open(EditMarketplaceCategoryModal , {
      width: '400px',
      data: {data: subCat.name, type: 'sub'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = {
          id: subCat.id,
          name: result.name,
          marketplaceCategoryId: catId
        };
        this.marketplaceCategoryService.addMarketplaceSubCategory(data).subscribe((res: any) => {
          if (res) {
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('marketplaces.marketplace_subcategory_edited');
            this.toastr.success(msg, title);
            let index = this.marketplaceCategories.findIndex(el => +el.id === +catId);
            if (index !== -1) {
              let subIndex = this.marketplaceCategories[index].marketplaceSubcategory.findIndex(el => +el.id === +subCat.id);
              if (subIndex !== -1) {
                this.marketplaceCategories[index].marketplaceSubcategory[subIndex].name = result.name;
              }
            }
          }
        });
      }
    });
  }

  deleteMarketplaceSubCategory (id, catId) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent,
      { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'Delete' , message: 'marketplaces.delete_marketplace_subcategory'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.marketplaceCategoryService.deleteMarketplaceSubCategory(id).subscribe((res: any) => {
          if (res && !res.error) {
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('marketplaces.marketplace_subcategory_deleted');
            this.toastr.success(msg, title);
            let index = this.marketplaceCategories.findIndex(el => +el.id === +catId);
            if (index !== -1) {
              let subIndex = this.marketplaceCategories[index].marketplaceSubcategory.findIndex(el => +el.id === +id);
              if (subIndex !== -1) {
                this.marketplaceCategories[index].marketplaceSubcategory.splice(subIndex, 1);
              }
            }
          }
        });
      }
    });
  }

  addMarketplaceSubCategory(catId) {
    const dialogRef = this.dialog.open(EditMarketplaceCategoryModal , {
      width: '400px',
      data: {type: 'create_sub'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = {
          name: result.name,
          marketplaceCategoryId: catId
        };
        this.marketplaceCategoryService.addMarketplaceSubCategory(data).subscribe((res: any) => {
          if (res) {
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('marketplaces.marketplace_subcategory_created');
            this.toastr.success(msg , title);
            let index = this.marketplaceCategories.findIndex(el => +el.id === +catId);
            if (index !== -1) {
              this.marketplaceCategories[index].marketplaceSubcategory.push(res);
            }
          }
        });
      }
    });
  }
}
